import { Resizable } from 're-resizable';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FileContext } from '../../../context/FileContext';
import RequiredIcon from '../../../assets/icons/astrik.svg';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg';
import { useTranslation } from 'react-i18next';
import { useColumnOrder } from '../../../hooks/useColumnOrder';

const Icon = styled.img``;

const OuterContainer = styled.div`
  border: 1px solid transparent !important;
  border-radius: 4px !important;
  padding: ${({ noPadding }) => noPadding ? '0' : '2px'};

  &.active {
    border: 1px solid #0073EA  !important;
    border-radius: 4px !important;
  }

  &.hover-active:hover {
    border: 1px solid #0073EA  !important;
    border-radius: 4px !important;
  }
`;

const TextInputContainer = styled.div`
  font-size: ${({ fontSize }) => fontSize + 'px'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
  padding-right: 8px;
  border: 1px solid #c5c7d0 !important;
  border-radius: 4px !important;
  width: 100%;
  height: 100%;
  background: ${({ color }) => (color ? color : 'white')};
  color: black;

  .icons {
    display: flex;
    align-items: center;
    gap: 7px;
  }
`;

const DropdownEditOverlayChip = ({ item, setIsResizing }) => {
  // height of container for text box on initialization
  const defaultHeight = 18.33;
  const defaultWidth = 150;
  const defaultFontSize = 11;

  const { t } = useTranslation();

  const {
    addedFormFields,
    updateFormFields,
    currentSelectedItem,
    draggableFieldsData,
  } = useContext(FileContext);
  const { mapColor } = useColumnOrder();
  const itemColor = item.color ?? item.signer?.color;
  const backgroundColor = itemColor
    ? mapColor(itemColor)
    : '#E6E6FA';

  const [fontSize, setFontSize] = useState(item.fontSize || defaultFontSize);

  useEffect(() => {
    if (!item?.width) item.width = defaultWidth;
    if (!item?.height) item.height = defaultHeight;
  }, []);

  const calculateFontSize = (addedHeight, prevHeight) => {
    const height = addedHeight + prevHeight;
    return parseInt(height) - parseInt(height) * 0.4;
  };

  const handleResizeStart = (_e, _dir) => {
    setIsResizing(true);
  };

  const handleResizeEnd = (item) => (_e, _dir, _ref, d) => {
    setIsResizing(false);

    item.fontSize = calculateFontSize(d.height, item?.height);
    item.width += d.width;
    item.height += d.height;

    setFontSize(item.fontSize);

    addedFormFields[currentSelectedItem.current] = item;
    draggableFieldsData[item.itemId] = {
      height: item.height,
      width: item.width,
      fontSize: item.fontSize,
    };
    updateFormFields([...addedFormFields]);
  };

  const handleResize = (e, _dir, _ref, d) => {
    setIsResizing(true);
    setFontSize(calculateFontSize(d.height, item.height));
  };
  const noPadding = item.noPadding || false;
  return (
    <>
      <OuterContainer className={item.isActive ? 'active' : 'hover-active'} noPadding={noPadding}>
        <Resizable
          size={{
            height: item?.height || defaultHeight,
            width: item?.width || defaultWidth,
          }}
          lockAspectRatio={true}
          enable={{
            top: false,
            right: item?.isActive,
            bottom: item?.isActive,
            left: false,
            topRight: false,
            bottomRight: item?.isActive,
            bottomLeft: false,
            topLeft: false,
          }}
          className={item.isActive ? 'resizeable' : ''}
          onResizeStart={handleResizeStart}
          onResizeStop={handleResizeEnd(item)}
          onResize={handleResize}
        >
          <TextInputContainer fontSize={fontSize} color={backgroundColor}>
            <div>--{item?.column?.label || t('Select')}--</div>
            <div className="icons">
              {item.required ? (
                <Icon
                  src={RequiredIcon}
                  alt=""
                  height={fontSize * 0.7}
                  width={fontSize * 0.7}
                />
              ) : null}
              <Icon
                src={ChevronDownIcon}
                alt="chevron down"
                height={fontSize}
                width={fontSize}
              />
            </div>
          </TextInputContainer>
        </Resizable>
      </OuterContainer>
    </>
  );
};

export default DropdownEditOverlayChip;
